const ROLE_LABELS = {
  Patient: 'Mentee',
  PatientPartner: 'Mentor',
  AccountAdmin: 'Account Admin',
  ClinicalUser: 'Clinical User',
  SuperUser: 'Super User',
};

const ROLE_CLASSES = {
  Patient: 'pp-role-patient',
  PatientPartner: 'pp-role-mentor',
  AccountAdmin: 'pp-role-account-admin',
  ClinicalUser: 'pp-role-clinical',
  SuperUser: 'pp-role-super-user',
};

export const roleLabelFor = (profileType) => ROLE_LABELS[profileType] || profileType || 'User';

export const roleClassFor = (profileType) => ROLE_CLASSES[profileType] || 'pp-role-other';
